export default __webpack_public_path__ + "static/media/green-tick.ce43d1ba.svg";